export { VerticalSegment } from './component'
